import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "../App";
import Inicio from "../views/Inicio";
import ArticulosRegistrados from "../views/Articulos/Articulos_registrados";
import ArticulosRegistrar from "../views/Articulos/registrar_articulos";
import SubCategorias from "../views/Articulos/subcategorias";
import PlandeCuentas from "../views/Articulos/plan_cuentas";
import TipoCategorias from "../views/Articulos/tipo_categorias";
import Categorias from "../views/Articulos/categorias";
import Almacen from "../views/Almacen/almacenes";
import TipoAlmacen from "../views/Almacen/tipo_almacen";
import UbicacionAlmacen from "../views/Almacen/ubicacion_almacen";
import Compras from "../views/Compras/gestion_compras";
import Importaciones from "../views/Compras/importacion";
import Proveedores from "../views/Compras/proveedores";
import TipoProveedores from "../views/Compras/tipo_proveedor";
import ControlInventario from "../views/Inventario/control_inventario";
import Colores from "../views/Inventario/colores";
import Unidades from "../views/Inventario/unidades";
import Paises from "../views/Configuracion/paises";
import Ciudades from "../views/Configuracion/ciudades";
import Usuarios from "../views/Usuarios/usuariospanel";
import Perfiles from "../views/Usuarios/perfiles";
import Permisos from "../views/Usuarios/permisos";
import Page404 from "../components/page404";
import Exitoso from "../views/Articulos/registroexitoso";
import ArticulosEditar from "../views/Articulos/articulos_editar";
import ArticuloActualizado from "../views/Articulos/ArtActualizado";
import DetallesCompras from "../views/Compras/detallescompras";
import ReportCompra from "../views/Compras/reportcompra";
import DetallesControl from "../views/Inventario/detallescontrol";
import InventarioDetalles from "../views/Inventario/inventariodetalles";
import DatosUsuarios from "../views/Usuarios/datosusuarios";
import CargarImagen from "../components/cargarimagen.";
import Bitacora from "../views/Bitacora/bitacora";
import Referidos from "../views/Articulos/Referidos";
import Depcancelados from "../views/Almacen/depcance";
import Usuario from "../views/Usuario";
import Producto1 from "../views/Producto1";
import Producto2 from "../views/Producto2";
import Producto3 from "../views/Producto3";
import UnirseCliente from "../views/UnirseCliente";
import Negocio1 from "../views/Negocio1";
import Negocio2 from "../views/Negocio2";
import Negocio3 from "../views/Negocio3";
import Comoafiliarse from "../views/Comoafiliarse";
import Salir from "../views/Salir";
import Mislanding from "../views/Mislanding";
import Iniciouser from "../views/Iniciouser";
import Misdatosuser from "../views/Misdatos";
import Pixels from "../views/Pixels";
import Leads from "../views/Leads";
import Leadstodos from "../views/Leadstodos";
import Actualizardatosuser from "../views/Actualizardatos";
import InformacionDelSistema from "../components/InformacionDelSistema";
import Cirpacademy from "../Cirp_academy";
import Modulo from "../moduleVideos";
import Contactanos from "../Contactanos";
import Recomiendaunamigo from "../views/Recomiendaunamigo";
import Invitaalaacademia from "../views/Invitalaacademia";
import Reportes from "../views/Reportes";
import Cursos from "../views/Cursos";
import Crearcursos from "../views/Crearcursos";
import Lecciones from "../views/Lecciones";
import Updatewhatsapp from "../views/updatewhatsapp";
import Encuesta from "../views/Encuesta";
import Reportesuser from "../views/Reportesuser";
import Clarity from "../views/Clarity";
import Membresias from "../views/Membresias";
import SeleccionTipoCampana from "../views/SeleccionTipoCampana";
import CampanaVideo from "../views/CampanaVideo";
import CampanaAudiencia from "../views/CampanaAudiencia";
import AudienciaLanding from "../views/AudienciaLanding";
import CrearNotificaciones from "../views/CrearNotificaciones";
import GestionarComentarios from "../views/GestionarComentarios";
import ChatIA from "../views/ChatIA";

const Router = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Page404 />}/>
          <Route path="/modulo/:cursoId" element={<Modulo/>} />
           <Route path="/clarity" element={<Clarity/>}/>
           <Route path="/membresias" element={<Membresias/>}/>
          <Route path="/seleccion-tipo-campana" element={<SeleccionTipoCampana/>}/>
          <Route path="/campana-video" element={<CampanaVideo/>}/>
          <Route path="/campana-audiencia" element={<CampanaAudiencia/>}/>
          <Route path="/audiencia/:usuario" element={<AudienciaLanding/>}/>
          <Route path="/crear-notificaciones" element={<CrearNotificaciones/>}/>
          <Route path="/gestionar-comentarios" element={<GestionarComentarios/>}/>
          <Route path="/chat-ia" element={<ChatIA/>}/>
           <Route path="/encuesta" element={<Encuesta/>}/>
           <Route path="/reportesuser" element={<Reportesuser/>}/>
          <Route path="/updatewhatsapp" element={<Updatewhatsapp/>}/>
          <Route path="/lecciones" element={<Lecciones/>}/>
          <Route path="/crearcursos" element={<Crearcursos/>}/>
          <Route path="/cursos" element={<Cursos/>}/>
          <Route path="/reportes" element={<Reportes/>}/>
          <Route path="/invitaalaacademia" element={<Invitaalaacademia/>}/>
          <Route path="/recomienda" element={<Recomiendaunamigo/>}/>
          <Route path="/contactanos" element={<Contactanos/>}/>
          <Route path="/cirpacademy" element={<Cirpacademy/>}/>
          <Route path="/informacion" element={<InformacionDelSistema/>}/>
          <Route path="/bitacora" element={<Bitacora/>}/>
          <Route path="/imagen" element={<CargarImagen/>}/>
          <Route path="/usuarios/info" element={<DatosUsuarios />}/>
          <Route path="/usuarios/permisos" element={<Permisos />}/>
          <Route path="/usuarios/perfiles" element={<Perfiles/>} />
          <Route path="/usuarios" element={<Usuarios/>} />
          <Route path="/ciudades" element={<Ciudades/>}/>
          <Route path="/depositostodos" element={<Paises/>} />
          <Route path="/trabajadores" element={<Colores/>} />
          <Route path="/inventario/unidades" element={<Unidades />}/>
          <Route path="/inventario/control/detalles/:idcontrol" element={<InventarioDetalles/>} />
          <Route path="/inventario/control/:id" element={<DetallesControl/>} />
          <Route path="/inventario" element={<ControlInventario/>} />
          <Route path="/compras/report/:idcompra" element={<ReportCompra/>} />
          <Route path="/compras/tipoproveedores" element={<TipoProveedores/>} />
          <Route path="/compras/proveedores" element={<Proveedores />}/>
          <Route path="/retirosprocesados" element={<Importaciones/>} />
          <Route path="/compras/detalles/:idcompra" element={<DetallesCompras/>} />
          <Route path="/retiros" element={<Compras/>} />
          <Route path="/tusdepositos" element={<UbicacionAlmacen/>} />
          <Route path="/depositoscancelados" element={<Depcancelados />}/>
          <Route path="/depositosprocesados" element={<TipoAlmacen />}/>
          <Route path="/depositos" element={<Almacen/>} />
          <Route path="/articulos/actualizado" element={<ArticuloActualizado/>} />
          <Route path="/articulos/editar/:idart" element={<ArticulosEditar/>} />
          <Route path="/articulos/exitoso" element={<Exitoso/>} />
          <Route path="/articulos/tipocategorias" element={<TipoCategorias/>} />
          <Route path="/articulos/plandecuentas" element={<PlandeCuentas/>} />
          <Route path="/articulos/subcategorias" element={<SubCategorias/>} />
          <Route path="/referidos" element={<Referidos />}/>
          <Route path="/mislanding" element={<Mislanding />}/>
          <Route path="/usuariossstrade" element={<Categorias />}/>
          <Route path="/articulos/registrar" element={<ArticulosRegistrar />}/>
          <Route path="/articulos" element={<ArticulosRegistrados/>}/>
          <Route path="/salir" element={<Salir/>} />
          <Route path="/comoafiliarse/:usuario" element={<Comoafiliarse />} />
          <Route path="/negocio3/:usuario" element={<Negocio3 />} />
          <Route path="/negocio2/:usuario" element={<Negocio2 />} />
          <Route path="/negocio1/:usuario" element={<Negocio1 />} />
          <Route path="/unirsecliente/:usuario" element={<UnirseCliente />} />
          <Route path="/producto3/:usuario" element={<Producto3 />} />
          <Route path="/producto2/:usuario" element={<Producto2 />} />
          <Route path="/producto1/:usuario" element={<Producto1 />} />
          <Route path="/actualizardatos" element={<Actualizardatosuser />} />
          <Route path="/leadstodos" element={<Leadstodos />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/pixels" element={<Pixels />} />
          <Route path="/misdatosuser" element={<Misdatosuser />} />
          <Route path="/:usuario" element={<Usuario />} />
          <Route path="/iniciouser" element={<Iniciouser/>} />
          <Route path="/inicio" element={<Inicio/>} />
          <Route path="/" element={<App/>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default Router;
